var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RoomList"},_vm._l((_vm.rooms),function(room,i){return _c('v-row',{key:i},[_c('v-col',{attrs:{"cols":"12"}},[_c('RoomCard',{attrs:{"room":room}})],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }